export default __webpack_public_path__ + "static/media/on-board-height.7860288b.svg";